module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA35"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.36.0.0.box.219.275.794.133.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.36.0.0.box.476.275.279.31.q.80"
    }
  }, [_vm._v("CHAPTER IV")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.36.0.1.box.219.372.794.36.q.70"
    }
  }, [_vm._v("A CHAT WITH AUNT MOLLIE.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.36.1.0.box.134.576.970.1300.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.36.1.0.box.134.576.967.398.q.60"
    }
  }, [_vm._v("WHEN the stranger looked from his window the next morning, the valley was still wrapped in its gray blanket. But when he and his host came from the house after breakfast, the sun had climbed well above the ridge, and, save a long, loosely twisted rope of fog that hung above the distant river, the mists were gone. The city man exclaimed with delight at the beauty of the scene.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.1.1.box.134.981.969.741.q.60"
    }
  }, [_vm._v("As they stood watching the sheep—white specks in the distance—climbing out of the valley where the long shadows still lay, to the higher, sunlit pastures, Mr. Matthews said, \"We've all been a talkin' about you this mornin', Mr. Howitt, and we'd like mighty well to have you stop with us for a spell. If I understood right, you're just out for your health anyway, and you'll go a long ways, sir, before you find a healthier place than this right here. We ain't got much such as you're used to, I know, but what we have is yourn, and we'd be proud to have you make yourself to home for as long as you'd like to stay. You see it's been a good while since we met up with anybody like you, and we count it a real favor to have you.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.1.2.box.135.1729.969.147.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.1.0"
    }
  }), _vm._v("Mr. Howitt accepted the invitation with evident pleasure, and, soon after, the mountaineer rode away to Bear Creek, on his quest for a man to herd"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.37.1.0.box.136.208.968.196.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA36.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA36.w.1.0.0"
    }
  }), _vm._v("\nsheep. Young Matt had already gone with his team to the field on the hillside west of the house, and the brown pony stood at the gate ready for Sammy Lane to return to her home on Dewey Bald.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA36"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.37.1.0.box.132.208.972.1645.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.1.1.box.137.412.967.243.q.60"
    }
  }, [_vm._v("\"I'd like the best in the world to stay, Aunt Mollie,\" she said, in answer to Mrs. Matthews' protest; \"but you know there is no one to feed the stock, and besides Mandy Ford will be back sometime today.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.1.2.box.135.662.968.291.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.1.2.0"
    }
  }), _vm._v("The older woman's arm was around the girl as they went down the walk. \"You must come over real often, now, honey; you know it won't be long 'til you'll be a leavin' us for good. How do you reckon you'll like bein' a fine lady, and livin' in the city with them big folks?\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.1.3.box.134.959.968.591.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.1.3.0"
    }
  }), _vm._v("The girl's face flushed, and her eyes had that wide questioning look, as she answered slowly, \"I don't know, Aunt Mollie; I ain't never seen a sure 'nough fine lady. I reckon them city folks are a heap different from us, but I reckon they're just as human. It would be nice to have lots of money and pretties, but somehow I feel like there's a heap more than that to think about. Any how,\" she added brightly, \"I ain't goin' for quite a spell yet, and you know 'Prechin' Bill' says, 'There ain't no use to worry 'bout the choppin' 'til the dogs has treed the coon.' I'll sure come over every day.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.1.4.box.133.1558.968.145.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.1.4.0"
    }
  }), _vm._v("Mrs. Matthews kissed the girl, and then, standing at the gate, watched until pony and rider had disappeared in the forest.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.1.5.box.132.1709.968.144.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.1.5.0"
    }
  }), _vm._v("Later Aunt Mollie, with a woman's fondness for a quiet chat, brought the potatoes she was preparing for dinner, to sit with Mr. Howitt on the porch. \"I"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.38.1.0.box.105.222.966.149.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.0.0"
    }
  }), _vm._v("\ndeclare I don't know how we'll do without Sammy,\" she said; \"I just can't bear to think of her goin' away.\"")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA37"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.38.1.0.box.104.222.969.1647.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.1.1.box.105.378.966.145.q.60"
    }
  }, [_vm._v("The guest, feeling that some sort of a reply was expected, asked, \"Is the family moving from the neighborhood?\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.1.2.box.104.529.969.1084.q.50"
    }
  }, [_vm._v("\"No, sir, there ain't no family to move. Just Sammy and her Pa, and Jim Lane won't never leave this country again. You see Ollie Stewart's uncle, his father's brother it is, ain't go no children of his own, and he wrote for Ollie to come and live with him in the city. He's to go to school and learn the business, foundry and machine shops, or something like that it is; and if the boy does what's right, he's to get it all some day. Ollie and Sammy has been promised ever since the talk first began about his goin'; but they'll wait now until he gets through his schoolin'. It'll be mighty nice for Sammy, marryin' Ollie, but we'll miss her awful; the whole country will miss her, too. She's just the life of the neighborhood, and everybody 'lows there never was another girl like her. Poor child, she ain't had no mother since she was a little trick, and she has always come to me for everything like, us bein' such close neighbors, and all. But law! sir, I ain't a blamin' her a mite for goin', with her Daddy a runnin' with that ornery Wash Gibbs the way he does.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.1.3.box.106.1630.966.134.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.3.0"
    }
  }), _vm._v("Again the man felt called upon to express his interest; \"Is Mr. Lane in business with this man Gibbs?\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.1.4.box.106.1781.967.88.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.4.0"
    }
  }), _vm._v("\"Law, no! that is, don't nobody know about any business; I reckon it's all on account of those old"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.39.1.0.box.111.215.973.694.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA38.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA38.w.1.0.0"
    }
  }), _vm._v("\nBald Knobbers; they used to hold their meetin's on top of Dewey yonder, and folks do say a man was burned there once, because he told some of their secrets. Well, Jim and Wash's daddy, and Wash, all belonged, 'though Wash himself wasn't much more than a boy then; and when the government broke up the gang, old man Gibbs was killed, and Jim went to Texas. It was there that Sammy's Ma died. When Jim come back it wasn't long before he was mighty thick again with Wash and his crowd down on the river, and he's been that way ever since. There's them that says it's the same old gang, what's left of them, and some thinks too that Jim and Wash knows about the old Dewey mine.\"")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA38"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.39.1.0.box.104.215.980.1650.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.1.1.box.105.917.977.143.q.60"
    }
  }, [_vm._v("Mr. Howitt, remembering his conversation with Jed Holland, asked encouragingly, \"Is this mine a very rich one?\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.1.2.box.104.1068.977.797.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.1.2.0"
    }
  }), _vm._v("\"Don't nobody rightly know about that, sir,\" answered Aunt Mollie. \"This is how it was: away back when the Injuns was makin' trouble 'cause the government was movin' them west to the territory, this old man Dewey lived up there somewhere on that mountain. He was a mighty queer old fellow; didn't mix up with the settlers at all, except Uncle Josh Hensley's boy who wasn't right smart, and didn't nobody know where he come from nor nothing; but all the same, 'twas him that warned the settlers of the trouble, and helped them all through it, scoutin' and such. And one time when they was about out of bullets and didn't have nothin' to make more out of, Colonel Dewey took a couple of men and some mules up on that mountain yonder in the night, and when they got back they was just loaded"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.40.1.0.box.106.223.970.691.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA39.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.0.0"
    }
  }), _vm._v("\ndown with lead, but he wouldn't tell nobody where he got it, and as long as he was with them, the men didn't dare tell. Well, sir, them two men was killed soon after by the Injuns, and when the trouble was finally over, old Dewey disappeared, and ain't never been heard tell of since. They say the mine is somewhere's in a big cave, but nobody ain't never found it, 'though there's them that says the Bald Knobbers used the cave to hide their stuff in, and that's how Jim Lane and Wash Gibbs knows where it is; it's all mighty queer. You can see for yourself that Lost Creek down yonder just sinks clean out of sight all at once; there must be a big hole in there somewhere.\"")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA39"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.40.1.0.box.105.223.971.1655.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.1.box.106.932.967.347.q.50"
    }
  }, [_vm._v("Aunt Mollie pointed with her knife to the little stream that winds like a thread of light down into the Hollow. \"I tell you, sir, these hills is pretty to look at, but there ain't much here for a girl like Sammy, and I don't blame her a mite for wantin' to leave. It's a mighty hard place to live, Mr. Howitt, and dangerous, too, sometimes.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.2.box.106.1286.966.138.q.50"
    }
  }, [_vm._v("\"The city has its hardships and its dangers too, Mrs. Matthews; life there demands almost too much at times; I often wonder if it is worth the struggle.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.3.box.105.1432.969.295.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.3.0"
    }
  }), _vm._v("\"I guess that's so,\" replied Aunt Mollie, \"but it don't seem like it could be so hard as it is here. I tell Mr. Matthews we've clean forgot the ways of civilized folks: altogether, though, I suppose we've done as well as most, and we hadn't ought to complain.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.4.box.107.1734.966.144.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.4.0"
    }
  }), _vm._v("The old scholar looked at the sturdy figure in its plain calico dress; at the worn hands, busy with their homely task; and the patient, kindly face,"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.41.1.0.box.105.216.970.591.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA40.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.0.0"
    }
  }), _vm._v("\nacross which time had ploughed many a furrow, in which to plant the seeds of character and worth. He thought of other women who had sat with him on hotel verandas, at fashionable watering places; women gowned in silks and laces; women whose soft hands knew no heavier task than the filmy fancy work they toyed with, and whose greatest care, seemingly, was that time should leave upon their faces no record of the passing years. \"And this is the stuff,\" said he to himself, \"that makes possible the civilization that produces them.\" Aloud, he said, \"Do you ever talk of going back to your old home?\"")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA40"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.41.1.0.box.104.216.972.1644.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.1.1.box.105.815.971.433.q.50"
    }
  }, [_vm._v("\"No, sir, not now;\" she rested her wet hands idly on the edge of the pan of potatoes, and turned her face toward the clump of pines. \"We used to think we'd go back sometime; seemed like at first I couldn't stand it; then the children come, and every time we laid one of them over there I thought less about leavin', until now we never talk about it no more. Then there was our girl, too, Mr. Howitt. No, sir, we won't never leave these hills now.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.1.2.box.104.1266.971.143.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.2.0"
    }
  }), _vm._v("\"Oh, you had a daughter, too? I understood from Mr. Matthews that your children were all boys.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.1.3.box.105.1416.971.444.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.3.0"
    }
  }), _vm._v("Aunt Mollie worked a few moments longer in silence, then arose and turned toward the house. \"Yes, sir, there was a girl; she's buried under that biggest pine you see off there a little to one side. We—we— don't never talk about her. Mr. Matthews can't stand it. Seems like he ain't never been the same since—since—it happened. 'Tain't natural for him to be so rough and short; he's just as good and kind inside as any man ever was or could be. He's real"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.42.1.0.box.156.244.968.548.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA41.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA41.w.1.0.0"
    }
  }), _vm._v("\ntaken with you, Mr. Howitt, and I'm mighty glad you're goin' to stop a spell, for it will do him good. If it hadn't been for Sammy Lane runnin' in every day or two, I don't guess he could have stood it at all. I sure don't know what we'll do now that she's goin' away. Then there's—there's—that at the ranch in Mutton Hollow; but I guess I'd better not try to tell you about that. I. wish Mr. Matthews would, though; maybe he will. You know so much more than us; I know most you could help us or tell us about things.\"")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA42.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42.w.0.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA41"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.42.1.0.box.156.244.968.548.q.50"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42.w.0.0.0.3"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b24a73d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0012.vue
// module id = 69
// module chunks = 0